import { render } from "./CorsiView.vue?vue&type=template&id=57ad0fc4"
import script from "./CorsiView.vue?vue&type=script&lang=js"
export * from "./CorsiView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__